export default "__VITE_ASSET__8ZINarcS__"